import { render, staticRenderFns } from "./I18nPicker.vue?vue&type=template&id=b26e6ac4&scoped=true&"
import script from "./I18nPicker.vue?vue&type=script&lang=js&"
export * from "./I18nPicker.vue?vue&type=script&lang=js&"
import style0 from "./I18nPicker.vue?vue&type=style&index=0&id=b26e6ac4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26e6ac4",
  null
  
)

export default component.exports